import { render } from "./AppManageInviteFriends.vue?vue&type=template&id=4a0eeac8&scoped=true"
import script from "./AppManageInviteFriends.vue?vue&type=script&lang=js"
export * from "./AppManageInviteFriends.vue?vue&type=script&lang=js"

import "./AppManageInviteFriends.vue?vue&type=style&index=0&id=4a0eeac8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0eeac8"]])

export default __exports__